import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-date-picker',
  templateUrl: './st-date-picker.component.html',
  styleUrls: ['./st-date-picker.component.scss'],
  standalone: false
})
export class StDatePickerComponent {

  @Input()
  idVal: string = 'datePickerId';

  @Input()
  inputVal?: string;

  @Input()
  placeholderVal = 'Type Here';

  @Input()
  label = '';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  disabled: boolean = false;

  @Output()
  onClick = new EventEmitter<Event>();
}
